// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sectionContainer .clickable,
.sectionContainer span {
  display: inline-flex;
  align-items: center;
  padding: 0.375em 0.82em;
  border-radius: 999px;
  border: 1px solid var(--palette-border);
  background: var(--palette-surface);
  color: var(--palette-text);
  font-size: 0.84rem;
  font-weight: 600;
  text-transform: lowercase;
  font-variant: small-caps;
  text-decoration: none;
  cursor: pointer;
  font-family: inherit;
  line-height: inherit;
}
.sectionContainer .clickable:focus-visible {
  outline: 2px solid var(--palette-primary);
  outline-offset: 2px;
}
/* Words the player did not find: dashed + muted */
.sectionContainer .clickable:not(.isFound) {
  color: var(--palette-text-muted);
  background: transparent;
  border-style: dashed;
}
.sectionContainer .clickable.isFound,
.sectionContainer .isFound {
  background: var(--palette-surface);
  color: var(--palette-text);
  font-weight: 600;
}
/* Currently highlighted on the board */
.sectionContainer .clickable.selected {
  border-color: var(--palette-primary);
  background: var(--palette-accent-soft);
  color: var(--palette-primary);
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/screens/components/puzzleWord.css"],"names":[],"mappings":"AAAA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,uCAAuC;EACvC,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;AACA,kDAAkD;AAClD;EACE,gCAAgC;EAChC,uBAAuB;EACvB,oBAAoB;AACtB;AACA;;EAEE,kCAAkC;EAClC,0BAA0B;EAC1B,gBAAgB;AAClB;AACA,uCAAuC;AACvC;EACE,oCAAoC;EACpC,sCAAsC;EACtC,6BAA6B;EAC7B,qBAAqB;AACvB","sourcesContent":[".sectionContainer .clickable,\n.sectionContainer span {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.375em 0.82em;\n  border-radius: 999px;\n  border: 1px solid var(--palette-border);\n  background: var(--palette-surface);\n  color: var(--palette-text);\n  font-size: 0.84rem;\n  font-weight: 600;\n  text-transform: lowercase;\n  font-variant: small-caps;\n  text-decoration: none;\n  cursor: pointer;\n  font-family: inherit;\n  line-height: inherit;\n}\n.sectionContainer .clickable:focus-visible {\n  outline: 2px solid var(--palette-primary);\n  outline-offset: 2px;\n}\n/* Words the player did not find: dashed + muted */\n.sectionContainer .clickable:not(.isFound) {\n  color: var(--palette-text-muted);\n  background: transparent;\n  border-style: dashed;\n}\n.sectionContainer .clickable.isFound,\n.sectionContainer .isFound {\n  background: var(--palette-surface);\n  color: var(--palette-text);\n  font-weight: 600;\n}\n/* Currently highlighted on the board */\n.sectionContainer .clickable.selected {\n  border-color: var(--palette-primary);\n  background: var(--palette-accent-soft);\n  color: var(--palette-primary);\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
